module.exports = __webpack_public_path__ + "static/media/logo_ricci.fc1860ed.png";